import React, { createContext, useContext } from 'react';

const SubscriptionContext = createContext({
  aiproUser: {
    plan_name: '',
    subscription_start: { date: '' },
    subscription_end: { date: '' }
  },
  loading: false,
});

export function SubscriptionProvider({ value, children }) {
  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}